import { render } from "./manageRoleCreateAndEdit.vue?vue&type=template&id=063bff8c&scoped=true"
import script from "./manageRoleCreateAndEdit.vue?vue&type=script&lang=js"
export * from "./manageRoleCreateAndEdit.vue?vue&type=script&lang=js"

import "./manageRoleCreateAndEdit.vue?vue&type=style&index=0&id=063bff8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-063bff8c"]])

export default __exports__